<template>
  <AppInput
    :value="value"
    :type="isHidePassword ? 'password' : 'text'"
    v-bind="$attrs"
    @input="$emit('input', $event)"
  >
    <template #append>
      <q-icon
        :name="isHidePassword ? 'fl:hide-pass-close' : 'fl:hide-pass'"
        class="cursor-pointer"
        color="grey-1"
        size="20px"
        @click="isHidePassword = !isHidePassword"
      />
    </template>
  </AppInput>
</template>

<script>
import AppInput from 'common/components/AppInput';

export default {
  name: 'AppPassword',
  components: { AppInput },
  props: {
    value: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      isHidePassword: true,
    };
  },
};
</script>
